export const PERMANENT_TABS_ID = {
  messaging: 100000000000
}
